<!--begin::Signin-->
<div class="login-form login-signin ">


    <div class="pb-11 pt-lg-0 pt-5" *ngIf="!isFinish">
        <h3 class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg">
            Summary</h3>
    </div>


    <div class="page-content page-container" id="page-content">

            <div class="row  d-flex justify-content-center ">
                <div class="col-12">
                    <div class="card user-card-full border-radius background-color">
                        <div class="row m-l-0 m-r-0">

                            <div class="col-sm-12 padding-14">
                                <div class="card-block">
                                    <div class="row">
                                        <!-- <div class="col-12">
                                            <p class="m-b-10 f-w-600">Gift</p>
                                            <ng-container *ngFor="let giftPerson of details">
                                                <ng-container *ngFor="let gift of giftPerson?.giftList">
                                                    <h6 class="text-muted f-w-400 color-black">{{giftPerson?.name }} - {{gift?.description}}</h6>
                                                </ng-container>
                                            </ng-container>
                                        </div> -->
                                        <ng-container *ngFor="let giftPerson of details">
                                            <ng-container *ngFor="let gift of giftPerson?.giftList">
                                                <div class="col-12 col-lg-6 align-self-center-sm" style="margin-top: 20px">
                                                    <p class="m-b-10 f-w-600">Gift ({{gift.giftType}})</p>
                                                    <h6 class="text-muted f-w-400 color-black">{{giftPerson?.name }}</h6>
                                                    <h6 class="text-muted f-w-400 color-black">{{gift?.description}}</h6>
                                                </div>
                                                </ng-container>
                                            </ng-container>
                                        <div *ngIf="details.length == 0">
                                            <h6 class="text-muted f-w-400 color-black " style="padding: 20px;">No Gifts Added</h6>
                                        </div>
                                        <!-- <div class="col-4"> -->
                                            <!-- <p class="m-b-10 f-w-600">Estate Backup</p> -->
                                            <!-- <ng-container>
                                                <h6 class="text-muted f-w-400 color-black">Grace Vitug Dela Cruz
                                                    2019 Honda City V3</h6>
                                            </ng-container> -->
                                            <!-- <h6 class="text-muted f-w-400 color-black">Christian Dela Cruz</h6>
                                            <h6 class="text-muted f-w-400 color-black">Grace Jung</h6> -->
                                        <!-- </div> -->
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12"  *ngIf="!isFinish">


                        <div class="pb-lg-0 pb-5 mt-4 ">
                            <button type="button" class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-9 width-150" (click)="editProfile()">
                                Edit
                            </button>
                        </div>


                        <!--begin::Action-->
                        <!-- <div class="pb-lg-0 pb-5 mt-4 margin-l-20">
                            <button id="kt_login_signin_submit" class="btn-save font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-3 margin-left-auto width-150"  (click)="navigateToNextPage()">
                                Next
                            </button>
                        </div> -->


                    </div>


            </div>



    </div>
</div>



